export default __webpack_public_path__ + "static/case03-4f7d42ddf908f745f6eaa2ab78b20389.webp";